import {takeLatest} from "redux-saga";
import {fork, put, take} from "redux-saga/effects";
import {generateUUID} from "../lib/UUID";
import * as AccountApiActions from "../actions/AccountApiActions";
import {
  showModalWindow,
  removeModalWindow,
  showWindow
  } from "../actions/WindowActions";

// Assign VIP Status
function* requestAssignCustomerVipStatus(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "AssignCustomerVipStatusWindow", {customerId: baseAction.customerId}, "Assign VIP Status"));
  yield take([AccountApiActions.ASSIGN_CUSTOMER_VIP_STATUS.CANCEL, AccountApiActions.ASSIGN_CUSTOMER_VIP_STATUS.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestAssignCustomerVipStatus() {
  yield takeLatest(AccountApiActions.REQUEST_ASSIGN_CUSTOMER_VIP_STATUS, requestAssignCustomerVipStatus);
}

// Unassign VIP Status
function* requestUnassignCustomerVipStatus(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "UnassignCustomerVipStatusWindow", {customerId: baseAction.customerId}, "Unassign VIP Status"));
  yield take([AccountApiActions.UNASSIGN_CUSTOMER_VIP_STATUS.CANCEL, AccountApiActions.UNASSIGN_CUSTOMER_VIP_STATUS.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestUnassignCustomerVipStatus() {
  yield takeLatest(AccountApiActions.REQUEST_UNASSIGN_CUSTOMER_VIP_STATUS, requestUnassignCustomerVipStatus);
}

function* requestDeleteCustomer(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "DeleteCustomerWindow", {customerId: baseAction.customerId}, "Delete Customer"));
  yield take([AccountApiActions.DELETE_CUSTOMER.CANCEL, AccountApiActions.DELETE_CUSTOMER.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestDeleteCustomer() {
  yield takeLatest(AccountApiActions.REQUEST_DELETE_CUSTOMER, requestDeleteCustomer);
}

// Toggles marketing communications for a customer
function* requestToggleMarketingCommunications(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ToggleMarketingCommunicationsWindow", {customerId: baseAction.customerId}, "Marketing Communications"));
  yield take([AccountApiActions.TOGGLE_MARKETING_COMMUNICATIONS.CANCEL, AccountApiActions.TOGGLE_MARKETING_COMMUNICATIONS.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestToggleMarketingCommunications() {
  yield takeLatest(AccountApiActions.REQUEST_TOGGLE_MARKETING_COMMUNICATIONS, requestToggleMarketingCommunications);
}


// Handle GUI for adding a new customer.
function* requestCreateCustomer(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "NewCustomerWindow", {}, "New Customer"));
  yield take([AccountApiActions.CREATE_CUSTOMER.CANCEL, AccountApiActions.CREATE_CUSTOMER.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestCreateCustomer() {
  yield takeLatest(AccountApiActions.REQUEST_CREATE_CUSTOMER, requestCreateCustomer);
}


// Handle GUI for adding a new account to customer.
function* requestAddAccount(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "AddAccountWindow", {customerId: baseAction.customerId}, "Add Account"));
  yield take([AccountApiActions.ADD_ACCOUNT.CANCEL, AccountApiActions.ADD_ACCOUNT.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestAddAccount() {
  yield takeLatest(AccountApiActions.REQUEST_ADD_ACCOUNT, requestAddAccount);
}

function* requestDeleteAccount(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "DeleteAccountWindow", {accountId: baseAction.accountId, customerId: baseAction.customerId}, "Delete Account"));
  yield take([AccountApiActions.DELETE_ACCOUNT.CANCEL, AccountApiActions.DELETE_ACCOUNT.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestDeleteAccount() {
  yield takeLatest(AccountApiActions.REQUEST_DELETE_ACCOUNT, requestDeleteAccount);
}

// Handle GUI for changing contact details of a customer.
function* requestChangeContactDetails(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ChangeContactDetailsWindow", {customerId: baseAction.customerId}, "Change Contact Details"));
  yield take([AccountApiActions.CHANGE_CONTACT_DETAILS.CANCEL, AccountApiActions.CHANGE_CONTACT_DETAILS.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchChangeContactDetails() {
  yield takeLatest(AccountApiActions.REQUEST_CHANGE_CONTACT_DETAILS, requestChangeContactDetails);
}


// Assign referral code to customer.
function* requestAssignReferralCode(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "AssignReferralCodeWindow", {customerId: baseAction.customerId}, "Assign Referral Code"));
  yield take([AccountApiActions.ASSIGN_REFERRAL_CODE.CANCEL, AccountApiActions.ASSIGN_REFERRAL_CODE.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestAssignReferralCode() {
  yield takeLatest(AccountApiActions.REQUEST_ASSIGN_REFERRAL_CODE, requestAssignReferralCode);
}

// Request delete shipping address.
function* requestEditShippingAddress(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "EditShippingAddressWindow", {accountId: baseAction.address.get("accountId"), addressId: baseAction.address.get("addressId")}, "Edit Shipping Address"));
  yield take([AccountApiActions.UPDATE_SHIPPING_ADDRESS.CANCEL, AccountApiActions.UPDATE_SHIPPING_ADDRESS.SUCCESS, AccountApiActions.REMOVE_SHIPPING_ADDRESS.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestEditShippingAddress() {
  yield takeLatest(AccountApiActions.REQUEST_EDIT_SHIPPING_ADDRESS, requestEditShippingAddress);
}

// Request delete shipping address.
function* requestRemoveShippingAddress(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "RemoveShippingAddressWindow", {accountId: baseAction.accountId, addressId: baseAction.addressId}, "Remove Shipping Address"));
  yield take([AccountApiActions.REMOVE_SHIPPING_ADDRESS.CANCEL, AccountApiActions.REMOVE_SHIPPING_ADDRESS.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestRemoveShippingAddress() {
  yield takeLatest(AccountApiActions.REQUEST_REMOVE_SHIPPING_ADDRESS, requestRemoveShippingAddress);
}


// Add shipping address.
function* requestAddShippingAddress(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "AddShippingAddressWindow", {accountId: baseAction.accountId}, "Add Shipping Address"));
  yield take([AccountApiActions.ADD_SHIPPING_ADDRESS.CANCEL, AccountApiActions.ADD_SHIPPING_ADDRESS.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestAddShippingAddress() {
  yield takeLatest(AccountApiActions.REQUEST_ADD_SHIPPING_ADDRESS, requestAddShippingAddress);
}

// Set billing address.
function* requestSetBillingAddress(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "SetBillingAddressWindow", {accountId: baseAction.accountId, address: baseAction.address}, "Set Billing Address"));
  yield take([AccountApiActions.SET_BILLING_ADDRESS.CANCEL, AccountApiActions.SET_BILLING_ADDRESS.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestSetBillingAddress() {
  yield takeLatest(AccountApiActions.REQUEST_SET_BILLING_ADDRESS, requestSetBillingAddress);
}

// change billing address.
function* requestChangeBillingAddress(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ChangeBillingAddressWindow", {accountId: baseAction.accountId}, "Change Billing Address"));
  yield take([AccountApiActions.CHANGE_BILLING_ADDRESS.CANCEL, AccountApiActions.CHANGE_BILLING_ADDRESS.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestChangeBillingAddress() {
  yield takeLatest(AccountApiActions.REQUEST_CHANGE_BILLING_ADDRESS, requestChangeBillingAddress);
}

// change billing tax info.
function* requestSetTaxInfo(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "SetTaxInfoWindow", {accountId: baseAction.accountId}, "Set Tax Info"));
  yield take([AccountApiActions.SET_TAX_INFO.CANCEL, AccountApiActions.SET_TAX_INFO.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestSetTaxInfo() {
  yield takeLatest(AccountApiActions.REQUEST_SET_TAX_INFO, requestSetTaxInfo);
}

// change billing tax exemption.
function* requestSetTaxExemption(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "SetTaxExemptionWindow", {accountId: baseAction.accountId}, "Set Tax Exemption"));
  yield take([AccountApiActions.SET_TAX_EXEMPTION.CANCEL, AccountApiActions.SET_TAX_EXEMPTION.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestSetTaxExemption() {
  yield takeLatest(AccountApiActions.REQUEST_SET_TAX_EXEMPTION, requestSetTaxExemption);
}

// Handle GUI for renaming an account
function* requestRenameAccount(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "RenameAccountWindow", {accountId: baseAction.accountId}, "Rename Account"));
  yield take([AccountApiActions.RENAME_ACCOUNT.CANCEL, AccountApiActions.RENAME_ACCOUNT.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestRenameAccount() {
  yield takeLatest(AccountApiActions.REQUEST_RENAME_ACCOUNT, requestRenameAccount);
}


// Add product to cart.
function* requestAddProductToCart(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "AddProductToCartWindow", {accountId: baseAction.accountId}, "Add Product to Cart"));
  yield take([AccountApiActions.ADD_PRODUCT_TO_CART.CANCEL, AccountApiActions.ADD_PRODUCT_TO_CART.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestAddProductToCart() {
  yield takeLatest(AccountApiActions.REQUEST_ADD_PRODUCT_TO_CART, requestAddProductToCart);
}

// Add subscription to cart.
function* requestAddSubscriptionToCart(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "AddSubscriptionToCartWindow", {accountId: baseAction.accountId}, "Add Subscription to Cart"));
  yield take([AccountApiActions.ADD_SUBSCRIPTION_TO_CART.CANCEL, AccountApiActions.ADD_SUBSCRIPTION_TO_CART.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestAddSubscriptionToCart() {
  yield takeLatest(AccountApiActions.REQUEST_ADD_SUBSCRIPTION_TO_CART, requestAddSubscriptionToCart);
}

// Edit subscription in Cart.
function* requestEditSubscriptionInCart(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "EditSubscriptionInCartWindow", {accountId: baseAction.accountId}, `Edit Subscription`));
  yield take([AccountApiActions.EDIT_SUBSCRIPTION_IN_CART.CANCEL, AccountApiActions.EDIT_SUBSCRIPTION_IN_CART.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestEditSubscriptionInCart() {
  yield takeLatest(AccountApiActions.REQUEST_EDIT_SUBSCRIPTION_IN_CART, requestEditSubscriptionInCart);
}

// Edit subscription in Cart.
function* requestChangeSubscriptionFrequency(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ChangeSubscriptionFrequencyWindow", {subscriptionId: baseAction.subscriptionId}, "Change Frequency"));
  yield take([AccountApiActions.CHANGE_SUBSCRIPTION_FREQUENCY.CANCEL, AccountApiActions.CHANGE_SUBSCRIPTION_FREQUENCY.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestChangeSubscriptionFrequency() {
  yield takeLatest(AccountApiActions.REQUEST_CHANGE_SUBSCRIPTION_FREQUENCY, requestChangeSubscriptionFrequency);
}

// Edit subscription in Cart.
function* requestChangeSubscriptionQuantity(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ChangeSubscriptionQuantityWindow", {subscriptionId: baseAction.subscriptionId, productSku: baseAction.productSku}, "Change Quantity"));
  yield take([AccountApiActions.CHANGE_SUBSCRIPTION_QUANTITY.CANCEL, AccountApiActions.CHANGE_SUBSCRIPTION_QUANTITY.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestChangeSubscriptionQuantity() {
  yield takeLatest(AccountApiActions.REQUEST_CHANGE_SUBSCRIPTION_QUANTITY, requestChangeSubscriptionQuantity);
}

// Edit subscription in Cart.
function* requestChangeSubscriptionProducts(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ChangeSubscriptionProductsWindow", {subscriptionId: baseAction.subscriptionId}, "Change Subscription"));
  yield take([AccountApiActions.CHANGE_SUBSCRIPTION_PRODUCTS.CANCEL, AccountApiActions.CHANGE_SUBSCRIPTION_PRODUCTS.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestChangeSubscriptionProducts() {
  yield takeLatest(AccountApiActions.REQUEST_CHANGE_SUBSCRIPTION_PRODUCTS, requestChangeSubscriptionProducts);
}

// Edit subscription shipping address.
function* requestChangeSubscriptionShippingAddress(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ChangeSubscriptionShippingAddressWindow", {accountId: baseAction.accountId, subscriptionId: baseAction.subscriptionId}, "Change Subscription Address"));
  yield take([AccountApiActions.CHANGE_SUBSCRIPTION_SHIPPING_ADDRESS.CANCEL, AccountApiActions.CHANGE_SUBSCRIPTION_SHIPPING_ADDRESS.SUCCESS, AccountApiActions.REQUEST_NEW_SUBSCRIPTION_SHIPPING_ADDRESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestChangeSubscriptionShippingAddress() {
  yield takeLatest(AccountApiActions.REQUEST_CHANGE_SUBSCRIPTION_SHIPPING_ADDRESS, requestChangeSubscriptionShippingAddress);
}

// Edit subscription shipping address.
function* requestNewSubscriptionShippingAddress(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "NewSubscriptionShippingAddressWindow", {accountId: baseAction.accountId, subscriptionId: baseAction.subscriptionId}, "Change Subscription Address"));
  yield take([AccountApiActions.NEW_SUBSCRIPTION_SHIPPING_ADDRESS.CANCEL, AccountApiActions.NEW_SUBSCRIPTION_SHIPPING_ADDRESS.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestNewSubscriptionShippingAddress() {
  yield takeLatest(AccountApiActions.REQUEST_NEW_SUBSCRIPTION_SHIPPING_ADDRESS, requestNewSubscriptionShippingAddress);
}

// Resume subscription scheduling.
function* requestResumeSubscriptionScheduling(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ResumeSubscriptionSchedulingWindow", {subscriptionId: baseAction.subscriptionId}, "Resume Subscription Scheduling"));
  yield take([AccountApiActions.RESUME_SUBSCRIPTION_SCHEDULING.CANCEL, AccountApiActions.RESUME_SUBSCRIPTION_SCHEDULING.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestResumeSubscriptionScheduling() {
  yield takeLatest(AccountApiActions.REQUEST_RESUME_SUBSCRIPTION_SCHEDULING, requestResumeSubscriptionScheduling);
}

// Pause subscription.
function* requestPauseSubscription(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "PauseSubscriptionWindow", {subscriptionId: baseAction.subscriptionId}, "Pause Subscription"));
  yield take([AccountApiActions.PAUSE_SUBSCRIPTION.CANCEL, AccountApiActions.PAUSE_SUBSCRIPTION.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestPauseSubscription() {
  yield takeLatest(AccountApiActions.REQUEST_PAUSE_SUBSCRIPTION, requestPauseSubscription);
}

// Cancel subscription.
function* requestCancelSubscription(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "CancelSubscriptionWindow", {subscriptionId: baseAction.subscriptionId}, "Cancel Subscription"));
  yield take([AccountApiActions.CANCEL_SUBSCRIPTION.CANCEL, AccountApiActions.CANCEL_SUBSCRIPTION.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestCancelSubscription() {
  yield takeLatest(AccountApiActions.REQUEST_CANCEL_SUBSCRIPTION, requestCancelSubscription);
}

// Restart subscription.
function* requestRestartSubscription(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "RestartSubscriptionWindow", {subscriptionId: baseAction.subscriptionId}, "Restart Subscription"));
  yield take([AccountApiActions.RESTART_SUBSCRIPTION.CANCEL, AccountApiActions.RESTART_SUBSCRIPTION.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestRestartSubscription() {
  yield takeLatest(AccountApiActions.REQUEST_RESTART_SUBSCRIPTION, requestRestartSubscription);
}

// Rename subscription.
function* requestRenameSubscription(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "RenameSubscriptionWindow", {subscriptionId: baseAction.subscriptionId}, "Rename Subscription"));
  yield take([AccountApiActions.RENAME_SUBSCRIPTION.CANCEL, AccountApiActions.RENAME_SUBSCRIPTION.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestRenameSubscription() {
  yield takeLatest(AccountApiActions.REQUEST_RENAME_SUBSCRIPTION, requestRenameSubscription);
}



// Add product in Cart.
function* requestEditProductInCart(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "EditProductInCartWindow", {accountId: baseAction.accountId, productId: baseAction.productId}, `Edit ${baseAction.productId}`));
  yield take([AccountApiActions.EDIT_PRODUCT_IN_CART.CANCEL, AccountApiActions.EDIT_PRODUCT_IN_CART.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestEditProductInCart() {
  yield takeLatest(AccountApiActions.REQUEST_EDIT_PRODUCT_IN_CART, requestEditProductInCart);
}

// Add credit card.
function* requestAddCreditCard(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "AddCreditCardWindow", {accountId: baseAction.accountId}, `Add Credit Card`));
  yield take([AccountApiActions.ADD_CREDIT_CARD.CANCEL, AccountApiActions.ADD_CREDIT_CARD.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestAddCreditCard() {
  yield takeLatest(AccountApiActions.REQUEST_ADD_CREDIT_CARD, requestAddCreditCard);
}

// Change credit card.
function* requestChangeCreditCard(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ChangeCreditCardWindow", {accountId: baseAction.accountId}, `Change Credit Card`));
  yield take([AccountApiActions.CHANGE_CREDIT_CARD.CANCEL, AccountApiActions.CHANGE_CREDIT_CARD.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestChangeCreditCard() {
  yield takeLatest(AccountApiActions.REQUEST_CHANGE_CREDIT_CARD, requestChangeCreditCard);
}

// Default credit card.
function* requestAssignDefaultCreditCard(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "AssignDefaultCreditCardWindow", {accountId: baseAction.accountId, paymentMethodId: baseAction.paymentMethodId}, `Assign Default Payment Method`));
  yield take([AccountApiActions.ASSIGN_DEFAULT_CREDIT_CARD.CANCEL, AccountApiActions.ASSIGN_DEFAULT_CREDIT_CARD.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestAssignDefaultCreditCard() {
  yield takeLatest(AccountApiActions.REQUEST_ASSIGN_DEFAULT_CREDIT_CARD, requestAssignDefaultCreditCard);
}

// Remove credit card.
function* requestRemoveCreditCard(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "RemoveCreditCardWindow", {accountId: baseAction.accountId, paymentMethodId: baseAction.paymentMethodId}, `Remove Card`));
  yield take([AccountApiActions.REMOVE_CREDIT_CARD.CANCEL, AccountApiActions.REMOVE_CREDIT_CARD.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestRemoveCreditCard() {
  yield takeLatest(AccountApiActions.REQUEST_REMOVE_CREDIT_CARD, requestRemoveCreditCard);
}

// Reschedule subscription delivery.
function* requestRescheduleSubscriptionDelivery(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "RescheduleSubscriptionDeliveryWindow", {subscriptionId: baseAction.subscriptionId}, "Reschedule Subscription Delivery"));
  yield take([AccountApiActions.RESCHEDULE_SUBSCRIPTION_DELIVERY.CANCEL, AccountApiActions.RESCHEDULE_SUBSCRIPTION_DELIVERY.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestRescheduleSubscriptionDelivery() {
  yield takeLatest(AccountApiActions.REQUEST_RESCHEDULE_SUBSCRIPTION_DELIVERY, requestRescheduleSubscriptionDelivery);
}

// View Charge payments.
function* requestViewChargePayments(baseAction) {
  let windowId = generateUUID();
  yield put(showWindow(windowId, "ChargePaymentsWindow", {accountId: baseAction.accountId, salesOrderId: baseAction.salesOrderId}, `Charge Payments`));
}
function* watchRequestViewChargePayments() {
  yield takeLatest(AccountApiActions.REQUEST_VIEW_CHARGE_PAYMENTS, requestViewChargePayments);
}

// View subscription log.
function* requestViewSubscriptionLog(baseAction) {
  let windowId = generateUUID();
  yield put(showWindow(windowId, "SubscriptionLogWindow", {subscriptionId: baseAction.subscriptionId}, `Subscription Log`));
}
function* watchRequestViewSubscriptionLog() {
  yield takeLatest(AccountApiActions.REQUEST_VIEW_SUBSCRIPTION_LOG, requestViewSubscriptionLog);
}

// View subscription deliver.
function* requestViewSubscriptionDelivery(baseAction) {
  let windowId = generateUUID();
  yield put(showWindow(windowId, "SubscriptionDeliveryWindow", {deliveryId: baseAction.deliveryId}, `Subscription Delivery`));
}
function* watchRequestViewSubscriptionDelivery() {
  yield takeLatest(AccountApiActions.REQUEST_VIEW_SUBSCRIPTION_DELIVERY, requestViewSubscriptionDelivery);
}


// Change billing method.
// function* requestChangeBillingMethod(baseAction) {
//   let windowId = generateUUID();
//   yield put(showModalWindow(windowId, "ChangeBillingMethodWindow", {accountId: baseAction.accountId}, `Billing for ${baseAction.accountId}`));
//   yield take([AccountApiActions.CHANGE_BILLING_METHOD.CANCEL, AccountApiActions.CHANGE_BILLING_METHOD.SUCCESS]);
//   yield put(removeModalWindow(windowId));
// }
// function* watchRequestChangeBillingMethod() {
//   yield takeLatest(AccountApiActions.REQUEST_CHANGE_BILLING_METHOD, requestChangeBillingMethod);
// }

// Change cart policies.
function* requestChangeCartPolicies(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ChangeCartPoliciesWindow", {accountId: baseAction.accountId}, `Cart Policies`));
  yield take([AccountApiActions.CHANGE_CART_POLICIES.CANCEL, AccountApiActions.CHANGE_CART_POLICIES.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestChangeCartPolicies() {
  yield takeLatest(AccountApiActions.REQUEST_CHANGE_CART_POLICIES, requestChangeCartPolicies);
}

// Set Payment Terms.
function* requestSetPaymentTerms(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "SetPaymentTermsWindow", {accountId: baseAction.accountId}, `Payment Terms`));
  yield take([AccountApiActions.SET_PAYMENT_TERMS.CANCEL, AccountApiActions.SET_PAYMENT_TERMS.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestSetPaymentTerms() {
  yield takeLatest(AccountApiActions.REQUEST_SET_PAYMENT_TERMS, requestSetPaymentTerms);
}

// Set Credit card.
function* requestSetPaymentCreditCard(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "SetPaymentCreditCardWindow", {accountId: baseAction.accountId}, `Credit Card`));
  yield take([AccountApiActions.SET_PAYMENT_CREDIT_CARD.CANCEL, AccountApiActions.SET_PAYMENT_CREDIT_CARD.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestSetPaymentCreditCard() {
  yield takeLatest(AccountApiActions.REQUEST_SET_PAYMENT_CREDIT_CARD, requestSetPaymentCreditCard);
}

// Change Billing Status.
function* requestChangeBillingStatus(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ChangeBillingStatusWindow", {accountId: baseAction.accountId}, `Billing Status`));
  yield take([AccountApiActions.CHANGE_BILLING_STATUS.CANCEL, AccountApiActions.CHANGE_BILLING_STATUS.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestChangeBillingStatus() {
  yield takeLatest(AccountApiActions.REQUEST_CHANGE_BILLING_STATUS, requestChangeBillingStatus);
}

// Record Payment.
function* requestRecordPayment(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "RecordPaymentWindow", {accountId: baseAction.accountId, salesOrderId: baseAction.salesOrderId}, `Record Payment`));
  yield take([AccountApiActions.RECORD_PAYMENT.CANCEL, AccountApiActions.RECORD_PAYMENT.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestRecordPayment() {
  yield takeLatest(AccountApiActions.REQUEST_RECORD_PAYMENT, requestRecordPayment);
}

function* requestCheckPaymentStatus(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "CheckPaymentStatusWindow", {salesOrderId: baseAction.salesOrderId}, `Check Payment Status`));
  yield take([AccountApiActions.CHECK_PAYMENT_STATUS.CANCEL, AccountApiActions.CHECK_PAYMENT_STATUS.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestCheckPaymentStatus() {
  yield takeLatest(AccountApiActions.REQUEST_CHECK_PAYMENT_STATUS, requestCheckPaymentStatus);
}

function* requestRetryPayment(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "RetryPaymentWindow", {salesOrderId: baseAction.salesOrderId}, `Retry Stripe Payment`));
  yield take([AccountApiActions.RETRY_PAYMENT.CANCEL, AccountApiActions.RETRY_PAYMENT.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestRetryPayment() {
  yield takeLatest(AccountApiActions.REQUEST_RETRY_PAYMENT, requestRetryPayment);
}


export default function* saga() {
  yield fork(watchRequestToggleMarketingCommunications);
  yield fork(watchRequestCreateCustomer);
  yield fork(watchRequestRenameAccount);
  yield fork(watchRequestAddAccount);
  yield fork(watchRequestDeleteAccount);
  yield fork(watchChangeContactDetails);
  yield fork(watchRequestAssignReferralCode);
  yield fork(watchRequestAddShippingAddress);
  yield fork(watchRequestEditShippingAddress);
  yield fork(watchRequestRemoveShippingAddress);

  yield fork(watchRequestAddProductToCart);
  yield fork(watchRequestEditProductInCart);

  yield fork(watchRequestAddSubscriptionToCart);
  yield fork(watchRequestEditSubscriptionInCart);

  yield fork(watchRequestChangeSubscriptionFrequency);
  yield fork(watchRequestChangeSubscriptionQuantity);
  yield fork(watchRequestChangeSubscriptionProducts);
  yield fork(watchRequestChangeSubscriptionShippingAddress);
  yield fork(watchRequestNewSubscriptionShippingAddress);
  yield fork(watchRequestResumeSubscriptionScheduling);
  yield fork(watchRequestPauseSubscription);
  yield fork(watchRequestCancelSubscription);
  yield fork(watchRequestRestartSubscription);
  yield fork(watchRequestRenameSubscription);

  // yield fork(watchRequestChangeBillingMethod);
  yield fork(watchRequestChangeCartPolicies);
  yield fork(watchRequestSetPaymentTerms);
  yield fork(watchRequestSetPaymentCreditCard);
  yield fork(watchRequestChangeBillingStatus);
  yield fork(watchRequestRecordPayment);
  yield fork(watchRequestSetBillingAddress);
  yield fork(watchRequestChangeBillingAddress);
  yield fork(watchRequestSetTaxInfo);
  yield fork(watchRequestSetTaxExemption);

  yield fork(watchRequestAddCreditCard);
  yield fork(watchRequestChangeCreditCard);
  yield fork(watchRequestAssignDefaultCreditCard);
  yield fork(watchRequestRemoveCreditCard);
  yield fork(watchRequestViewChargePayments);
  yield fork(watchRequestRescheduleSubscriptionDelivery);
  yield fork(watchRequestCheckPaymentStatus);
  yield fork(watchRequestRetryPayment);

  yield fork(watchRequestViewSubscriptionLog);
  yield fork(watchRequestViewSubscriptionDelivery);

  yield fork(watchRequestAssignCustomerVipStatus);
  yield fork(watchRequestUnassignCustomerVipStatus);
  yield fork(watchRequestDeleteCustomer);
}
